var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGanttSortDown(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 6,
    viewBox: "0 0 10 6",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.391833 1.05935C0.499579 0.820353 0.73742 0.666687 0.9996 0.666687H8.99959C9.26179 0.666687 9.49959 0.82042 9.60739 1.05942C9.71513 1.29842 9.67273 1.57842 9.49913 1.77489L9.49806 1.77602C9.47433 1.80262 9.40666 1.87829 9.36493 1.92435C9.28019 2.01775 9.15853 2.15069 9.00939 2.30989C8.71173 2.62775 8.30186 3.05355 7.85646 3.48102C7.41393 3.90575 6.92293 4.34515 6.46453 4.68269C6.23579 4.85115 6.00079 5.00489 5.77333 5.11915C5.55959 5.22655 5.28659 5.33335 4.99959 5.33335C4.71253 5.33335 4.43953 5.22655 4.22579 5.11915C3.99833 5.00489 3.76339 4.85115 3.5346 4.68269C3.07621 4.34515 2.58521 3.90575 2.14267 3.48102C1.69728 3.05349 1.28743 2.62775 0.989753 2.30989C0.840626 2.15062 0.718966 2.01775 0.634273 1.92429C0.592386 1.87809 0.524626 1.80229 0.501119 1.77602L0.500346 1.77515C0.326726 1.57869 0.284079 1.29842 0.391833 1.05935Z",
    fill: "#C3C4C9"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGanttSortDown);
export default __webpack_public_path__ + "static/media/gantt-sort-down.e74a090b42bb11b1775c64e802052d1d.svg";
export { ForwardRef as ReactComponent };